module.exports = __webpack_public_path__ + "img/liberia.3a9dbe4c.png";